import {
  datetime_format_hours_minutes_ampm,
  datetime_format_month_day,
  datetime_format_month_day_time,
  datetime_format_month_day_year,
  datetime_format_month_day_year_time,
} from "./DateTime.constants";
import {
  parseISO,
  formatRelative,
  isToday,
  parse,
  isBefore,
  format,
} from "date-fns";
import { enUS } from "date-fns/locale";

export const getCustomRelativeDayFormat = (
  timestamp?: number | Date | string,
) => {
  if (!timestamp) return;
  // Custom locale to exclude time in formatRelative
  const customLocale = {
    ...enUS,
    formatRelative: (token: string) => {
      const formatWithoutTime: Record<string, string> = {
        yesterday: "'Yesterday'",
        today: "'Today'",
        tomorrow: "'Tomorrow'",
        nextWeek: "'Next' eeee",
        other: "dd/MM/yyyy",
      };
      return formatWithoutTime[token];
    },
  };
  return formatRelative(timestamp, Date.now(), {
    locale: customLocale,
  });
};

/**
 * Checks if a given date string represents today's date.
 * @param {string} dateString - The date string to check.
 * @returns {boolean} Returns true if the date string represents today's date, false otherwise.
 */

export const isDateToday = (dateString) => {
  if (!dateString) return false;

  const date = parseISO(dateString);

  if (!date) return false;

  return isToday(date);
};

/**
 * Checks if a given date string represents a past time based on the provided format.
 * @param {Object} params - The parameters object.
 * @param {string} params.dateString - The date string to check.
 * @param {string} params.format - The format of the date string.
 * @returns {boolean} Returns true if the date string represents a past time, false otherwise.
 */
export const isPastTime = ({ dateString, format }) => {
  const parsedDate = parse(dateString, format, new Date());
  const isPast = isBefore(parsedDate, new Date());
  return isPast;
};

export const formatDateTime = (
  date: Date,
  options?: { showTime?: boolean; showYear?: boolean },
) => {
  const time = options?.showTime ?? false;
  const year = options?.showYear ?? false;
  if (time && year) {
    return format(date, datetime_format_month_day_year_time);
  } else if (time) {
    return format(date, datetime_format_month_day_time);
  } else if (year) {
    return format(date, datetime_format_month_day_year);
  } else {
    return format(date, datetime_format_month_day);
  }
};

export const formatTime = (date: Date) =>
  format(date, datetime_format_hours_minutes_ampm);
